<script>
export default {
  emits: ["refetch-options", "input"],
  props: {
    // selectedValue
    value: {
      type: Object,
      required: false,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: "Seleccione una opción",
    },
    required: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    keyValue: {
      type: String,
      default: "key",
    },
    labelValue: {
      type: String,
      default: "value",
    },
  },
  data() {
    return {
      search: undefined,
      showContent: false,
    };
  },
  computed: {
    selectedOption() {
      if (this.options?.length > 0) {
        return this.options.find(
          (option) => option[this.keyValue] == this.selectedValue[this.keyValue]
        );
      }
    },
    hasOptions() {
      return this.options.length > 0;
    },
  },
  methods: {},
  watch: {},
};
</script>

<template>
  <div
    class="relative w-full cursor-default"
    v-click-outside="() => (showContent = false)"
  >
    {{ options }}
    <div
      @click="
        () => {
          if (!disabled) {
            showContent = !showContent;
          }
        }
      "
      class="flex flex-row text-nowrap items-center justify-between w-full h-[30px] bg-[#F0F5FA] border-[0px] px-1 rounded-sm"
    >
      {{
        selectedOption
          ? selectedOption[labelValue]
          : placeholder ?? "Seleccione una opción"
      }}
      <fas :icon="['fas', 'chevron-down']"></fas>
    </div>
    <div v-if="showContent" class="absolute top-10 left-0 w-full z-30">
      <input
        class="w-full"
        v-model="search"
        placeholder="Buscar..."
        @input="
          () => {
            if (search) $emit('refetch-options', search);
          }
        "
      />
      <div
        class="sm:max-h-48 xl:max-h-[350px] border-[1px] border-slate-100 w-full flex flex-col bg-white overflow-auto"
      >
        <div
          v-for="(option, i) in options"
          :key="i"
          class="border-b-[1px] p-2 border-gray-200 hover:bg-gray-200 transition-all"
          :class="[
            option[keyValue] == selectedOption[keyValue]
              ? 'bg-primary/90 text-white'
              : '',
          ]"
          @click="
            () => {
              showContent = false;
              $emit('input', option);
            }
          "
        >
          {{ option[labelValue] ?? "-" }}
        </div>
      </div>
    </div>
  </div>
</template>
